import {debug} from "@/api/logging"
const column_name_mapping_ = require("@/locales/zh-TW.json")
debug('column_name_mapping_', column_name_mapping_)
const column_name_mapping = {
  content: '內文',
  title: '標題',
  title2: '並列標題',
  authors: '作者',
  sourcesdes: '出處',
  word: '單字',
  uniname: '期刊',
  journal: '期刊',
  journal_name: '期刊',
  pubtime: '出版時間',
  pubyear: '年份',
  volno: '期別',
  dynasty: '朝代',
  imagedes: '圖片說明',
  field: '欄位',
  fields: '欄位',
  column: '專欄',
  keyword: '論文關鍵詞',
  keywords: '論文關鍵詞',
  keyword2: '關鍵詞',
  post_classification: '後分類',
  post_classification_: {
    journal: '期刊/類別',
    keyword: '主題關鍵詞',
    keywords: '主題關鍵詞',
  },
  search_: {
    includes: "包含字詞",
    must: "含以下所有字詞",
    must_not: "不含以下任何字詞",
    should: "含以下任何字詞",
  }
}

export {
  column_name_mapping_ as column_name_mapping,
}
